import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { getFirstURL } from '@core/helper';
import { AuthService } from '@core/services/apis';

@Injectable()
export class NotAuthGuard implements CanActivate {
  constructor(private _authService: AuthService, private _router: Router) {}

  canActivate(): boolean {
    const isRefreshTokenExpired = this._authService.isRefreshTokenExpired;
    if (!this._authService.loggedIn() && isRefreshTokenExpired) {
      return true;
    } else {
      const url = getFirstURL();
      this._router.navigate([url]);
      return false;
    }
  }
}
